<template lang="pug">
  router-link.cart-widget(to="/korzina")
    SvgIcon(name="cart" width="26" height="22" class="cart-widget__ico")
    .cart-widget__count
      .cart-widget__count-num 0
</template>

<script>
import EventBus from '@/eventBus';
//import '@/components/common/cartWidget/cartWidget.styl';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
  components: {
    SvgIcon
  },

  name: "cartWidget",

  mixins: [ImagePreloaderVue],

  props: {

  },

  created() {

  },

  methods: {

  }
}
</script>
